import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/firebase-auth'


// configuaracion de conexion a Firebase
const app = firebase.initializeApp({
  apiKey: "AIzaSyBBlv0k7RXN-lmfXfGWjUxgnt_zslfv798",
    authDomain: "tienda-fn.firebaseapp.com",
    projectId: "tienda-fn",
    storageBucket: "tienda-fn.appspot.com",
    messagingSenderId: "416063725495",
    appId: "1:416063725495:web:16d508d2ca464cd4849232"
});

export function getFirebase(){
    return app;
}

export function getFirestore(){
    return firebase.firestore(app)
}

//inicio de login y autentificacion con Gmail
export const auth = firebase.auth();

const googleProvider = new firebase.auth.GoogleAuthProvider()

export const signInWithGoogle = () => {

  auth.signInWithPopup(googleProvider).then((res) => { 
    console.log(res.user)
  }).catch((error) => {
    console.log(error.message)
  })

}
//cerrado de sesion
export const logOut = () => {
  auth.signOut().then(()=> {
    console.log('logged out')
  }).catch((error) => {
    console.log(error.message)
  }) 
}
